/**
 * Normalize a URL by prepending http:// if no protocol is present.
 */
export function normalizeUrl(url) {
  if (!url) return '';
  if (!url.startsWith('http://') && !url.startsWith('https://')) {
    return `http://${url}`;
  }
  return url;
}

/**
 * Validate and sanitize a URL. Returns null for unsafe URLs.
 */
export function safeUrl(url) {
  if (!url) return null;
  const normalized = normalizeUrl(url);
  try {
    const parsed = new URL(normalized);
    if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') return null;
    return url;
  } catch {
    return null;
  }
}
